import { browserHistory } from './browser-history';

interface OnNavigateProps {
  href: string;
  event: React.MouseEvent<HTMLAnchorElement>;
  [key: string]: unknown;
}

export const onNavigate = ({ event, href, ...args }: OnNavigateProps): void => {
  if (
    !(
      event.button > 1 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      href?.startsWith('mailto:')
    )
  ) {
    event.preventDefault();

    if (!href) return;

    if (args.replace as boolean) {
      browserHistory.replace(href, (args.state as Record<string, unknown>) ?? {});
    } else {
      browserHistory.push(href, (args.state as Record<string, unknown>) ?? {});
    }
  }
};
